import { VuexModule, Module, Mutation } from 'vuex-module-decorators'

@Module
export class SearchFilterOptions extends VuexModule {
    search = ''
    rallyId = -1
    rallyRoundId = -1

    @Mutation
    updateSearch (search: string) {
      this.search = search
    }

    @Mutation
    updateRallyId (rallyId: number) {
      this.rallyId = rallyId
    }

    @Mutation
    updateRallyRoundId (rallyRoundId: number) {
      this.rallyRoundId = rallyRoundId
    }
}
